import { ProductOPReq } from '@cemex-core/cmx-api';
import { createSelector } from '@ngrx/store';
import { getAdtMainSelector, getJobsiteSelected, getSelectedBusinessLine } from '@ordersnproducts/modules/order-builder/reducers';

/**
 * Main selector of ADT Products
 */
export const getAdtProductsMainSelector = createSelector(getAdtMainSelector, state => {
    return state.productsState;
});

/**
 * Selector to get all ADT products of customer selected
 */
export const getAdtProducts = createSelector(getAdtProductsMainSelector, state => {
    return state.products;
});

/**
 * Get current loading status
 */
export const getAdtProductsLoadingStatus = createSelector(getAdtProductsMainSelector, state => {
    return state.loading;
});

/**
 * Get balance of the product based on the contract selected
 */
export const getAdtBalanceProducts = createSelector(getAdtProductsMainSelector, state => {
    return state.productContractBalancesSelected;
});

/**
 * Get loading status
 */
export const getproductLoadingStatus = createSelector(getAdtProductsMainSelector, state => {
    return state.loading;
});

/**
 * Get selected products
 */
export const getSelectedProducts = createSelector(getAdtProductsMainSelector, state => {
    return state.selectedProducts;
});

/**
 * Get payload to fetch admixture products
 */
export const getFetchProductPayload = createSelector(
    getJobsiteSelected,
    getSelectedBusinessLine,
    (jobsite, businessLine) => {
        return {
            productTypeId: businessLine.productTypeId,
            jobsiteId: jobsite.shipmentLocationId,
        } as ProductOPReq;
    },
);
